import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import type { RolePermissions } from "@/hooks/useRolePermissions";

interface RoleRouteProps {
  children: React.ReactNode;
  permission: keyof RolePermissions;
}

/**
 * Route guard that checks if the current user has the required permission.
 * Redirects to dashboard if permission is denied.
 */
export function RoleRoute({ children, permission }: RoleRouteProps) {
  const { permissions } = useAuth();

  if (!permissions[permission]) {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
}
